<template>
    <div>
      <button
        style="display: none"
        type="button"
        :class="`btn-confirm-modal-rearrange-${id}`"
        data-bs-toggle="modal"
        :data-bs-target="`#ModalConfirmRearrange${id}`"
      ></button>
      <button
        style="display: none"
        type="button"
        :class="`btn-close-modal-rearrange-${id}`"
        data-bs-dismiss="modal"
        :data-bs-target="`#ModalConfirmRearrange${id}`"
      ></button>
      <div
        class="modal fade"
        :id="`ModalConfirmRearrange${id}`"
        tabindex="-1"
        :aria-labelledby="`modalConfirmRearrange${id}Label`"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">{{ message }}</div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-success btn-background btn-sm"
                @click="processYes"
              >
                Yes
              </button>
              <button
                type="button"
                class="btn btn-primary btn-close-modal btn-sm"
                @click="closeModal"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import $ from 'jquery';
  export default {
    name: "ModalConfirmRearrange",
    props: {
      id: {
        type: String,
        required: true,
      },
      message: {
        type: String,
        default: "",
      },
      btnYes: {
        type: String,
        default: "",
      },
      processNo: {
        type: Function,
        default: () => {},
      },
      processYes: {
        type: Function,
        default: () => {},
      },
    },
    methods: {
      closeModal() {
        $(`.btn-close-modal-rearrange-${this.id}`).click();
      },
    },
  };
  </script>

